import { IInputNode, QuestionNode } from '../../../actionCard'

export class DateTimeQuestionNode extends QuestionNode implements IInputNode<Date | undefined> {
  public getValue(): Date | undefined {
    return getDateValue(this.data.value as string)
  }

  public setValue(value?: Date): void {
    const oldValue = this.getValue()
    this.data.value = this.__getStringValue(value)
    const newValue = this.getValue()

    this.nodeSettings?.observer?.onValueSet?.(this, newValue, oldValue)
  }

  public getStringValue(): string {
    return this.__getStringValue(this.getValue()) ?? ''
  }

  public setStringValue(value?: string): void {
    const valueDate = getDateValue(value)
    this.setValue(valueDate)
  }

  public stringifyValue(): string {
    const value = this.getValue()
    return !value || isNaN(value.getTime()) ? '' : value.toLocaleString()
  }

  protected __getStringValue(value?: Date): string | undefined {
    return value ? value.toISOString() : undefined
  }
}

function getDateValue(value?: string): Date | undefined {
  if (!value) {
    return
  }
  const valueDate = new Date(value)
  return isNaN(valueDate.getTime()) ? undefined : valueDate
}
